import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Save from './save';
import Edit from './Edit';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
				fill="currentColor"
			>
				{ /* Ascending bars — represents counting up */ }
				<rect x="2" y="15" width="4" height="7" rx="1" />
				<rect x="8" y="10" width="4" height="12" rx="1" />
				<rect x="14" y="5" width="4" height="17" rx="1" />
				{ /* Up arrow on the right */ }
				<path d="M21 2.5l-2.5 3h1.75v4a.75.75 0 0 0 1.5 0v-4H23.5l-2.5-3z" />
			</svg>
		),
	},
} );
